module.exports = __webpack_public_path__ + "static/media/search.d3845fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/search.png
// module id = 36
// module chunks = 0